import { type GetLifeDetailResponse, InsuredPersonRole } from "@repo/api";
import { BodyTextS, cs } from "@repo/ui";
import { type FC } from "react";
import { useLifeDetail } from "../../../queryHooks";
import { InlineLifeDescriptionSkeleton } from "./LifeCardDescription.styled";

interface ILifeCardDescriptionProps {
	contractId: string;
	frequency?: boolean;
}

const LifeCardDescription: FC<ILifeCardDescriptionProps> = ({
	contractId,
	frequency = false,
}) => {
	const {
		data: life,
		isLoading,
		isSuccess,
	} = useLifeDetail<GetLifeDetailResponse>({ id: contractId });

	if (isLoading)
		return <InlineLifeDescriptionSkeleton />;

	if (isSuccess) {
		const firstInsuredPerson = life.insuredPersons.find(
			(p) =>
				InsuredPersonRole.First === p.role ||
				InsuredPersonRole.PolicyHolderAndFirst === p.role
		);
		if (frequency && life.paymentInfo?.list) {
			return <>{cs.frequencies2[life.paymentInfo.list[0].client.frequency]}</>;
		} else if (firstInsuredPerson) {
			let text = "";
			if (firstInsuredPerson.firstName) text = firstInsuredPerson.firstName;
			if (firstInsuredPerson.lastName)
				text += ` ${firstInsuredPerson.lastName}`;
			if (firstInsuredPerson.dateOfBirth)
				text += ` (${new Date(firstInsuredPerson.dateOfBirth).getFullYear()})`;

			return <BodyTextS mb={0}>{text}</BodyTextS>;
		} else {
			console.warn("Na smlouvě chybí první pojištěná osoba");
			return <>Na smlouvě chybí první pojištěná osoba</>;
		}
	}
	return null;
};

export default LifeCardDescription;
